module.exports = __webpack_public_path__ + "static/loughhead-ba950be8355c67545277512a79009f32.jpg";